import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React from 'react';
import cx from '../../styles';
// import { Icon } from '../Common/Icon';
// import { ProfileThumb } from '../Common/CardComponents';
import {gtmSend} from '../../helpers';
import appendResizeKey from '@tickled-media/components.tm-helper-append-resize-key-new'

export const SuggestedArticleCard = ({data}) => {
    const imageUrl = data.image ? data.image : generateAssetCdnUrl("tap-assets", "TAP_icon.png");
    return (
        <div className={cx("article-post-card-warp")}>
            <div className={cx("card-type-article")}>
                <div className={cx("card-head")}> 
                    <div className={cx("img-bg-wrap")} style={{backgroundImage: `url("${imageUrl}")`}}>
                        <a href={data.link}>
                            <img src={imageUrl} alt="suggested article" loading="lazy"/>
                        </a>
                    </div>
                </div> 
                <div className={cx("card-body")}>
                    <div className={cx("category-share-wrap")}>
                        <aside className={cx("left")}></aside>
                        <aside className={cx("right")}>
                            {/*<a href="#" onClick={(e) => {e.preventDefault()}}>
                                <Icon name='icon-article-share-fb' className={cx("icon-fb-share")}/>
                            </a>
                            <a href="#" onClick={(e) => {e.preventDefault()}} className={cx("only-mobile")}>
                                <Icon name="icon-article-share-whatsapp" />
                            </a>
                            <a href="#" onClick={(e) => {e.preventDefault()}}>
                                <Icon name='icon-article-share-link' />
                            </a>*/}
                        </aside>
                    </div>
                    <div className={cx("title-wrap")}>
                        <a href={data.link}>
                            <span className={cx("title")}>
                                {data.title}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}


export const RelatedArticleCard = ({elems=[], t, match}) => {
    return (
        <div className={cx("shadow-card", "related-article-posts")}>
            <div className={cx("header-wrap")}>
                <div>{t("article_related")}</div>
            </div>
            <ul>
                {
                    elems.map((elem, i) => {
                        return (
                            <li key={i} className={cx('related-article-wrapper')}>
                                <div>
                                    <a href={`${elem.url}?utm_source=community&utm_medium=posts&utm_campaign=related`} target="_blank" rel="noopener noreferrer" onClick={() => gtmSend('dynamic', 'Related Article', 'click', match.path)}>
                                        <img src={elem.image ? appendResizeKey(elem.image, '350') : generateAssetCdnUrl("tap-assets", "TAP_icon.png")} alt="article cover" loading="lazy" width="80" height="80" />
                                    </a>
                                </div>
                                <div className={cx('related-article-title')}>
                                    <a href={`${elem.url}?utm_source=community&utm_medium=posts&utm_campaign=related`} target="_blank" rel="noopener noreferrer" onClick={() => gtmSend('dynamic', 'Related Article', 'click', match.path)}>
                                        {elem.title}
                                    </a>
                                </div>                              
    
                                    {/* <p>
                                        <a href={elem.url} target="blank">
                                            {elem.excerpt}
                                        </a>
                                    </p> */}
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );

}